export default "__VITE_ASSET__9e171628__"